/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  authService = inject(AuthService);

  token?: string;
  cogToken?: string;

  constructor() {
    this.authService.token$.subscribe((token) => {
      this.token = token;
    });
    this.authService.cognitoToken$.subscribe((token) => {
      this.cogToken = token;
    });
  }

  /** addToken
   * Adds the Authorization header with the token stored in the session via the Auth Service
   */
  static addTokens(request: HttpRequest<any>, token: string, cogToken: string, connectionId: string | undefined) {
    const headers: {[header: string]:string } = {
      Authorization: `Bearer ${token}`,
      'X-Cognito-Access-Token': `Bearer ${cogToken}`
    };

    if (request.url.indexOf('preverificationapi') < 0) {
      headers['X-ACADV-ConnectionId'] = connectionId || '';
    }

    return request.clone({ setHeaders: headers })
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only add the header if there is a token and it's not a direct AWS call
    // Check if the URL is an S3 URL (amazonaws.com or s3)
    const isS3Request = request.url?.indexOf('amazonaws.com') >= 0 || request.url?.indexOf('.s3.') >= 0;

    // Specifically when getting a refresh token, do not include bearer token (causes CORS/500 error)
    const isTokenEndpoint = request.url?.indexOf('getOAuth2Token') >= 0;

    if (this.token && this.cogToken && !isS3Request && !isTokenEndpoint) {
      request = TokenInterceptor.addTokens(request, this.token, this.cogToken, this.authService.getConnectionId());
    }

    return next.handle(request).pipe(
      tap((event) => {
        // If there was a successful response refresh the session authorization data
        if (event instanceof HttpResponse && event.body && event.body.isSuccessful && event.headers.get('authorization')) {
          this.authService.setAuth(JSON.parse(event.headers.get('authorization') || ''));
        }
      })
    );
  }
}
